export default {
    type: String,
    default: 'light',
    validator: (value: string) => {
        return ['light', 'dark'].includes(value);
    },
};
